import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DEFAULT_OG_IMAGE = 'https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Logo+Mark%402x.png';

// PMS product pages — canonical points to MAM (the SEBI-registered PMS entity)
// to avoid duplicate content across maxiomwealth.com and maxiomassetmanagement.com
const PMS_CANONICAL_PREFIXES = [
  '/jewel-pms', '/spark-pms', '/gem-pms',
  '/pms/', '/pms-pricing', '/pms-factsheets',
  '/coral-sectorial-pms', '/coral-factor-pms',
];

const PageTitle = ({
  title,
  description = 'Maxiom Wealth - Your Partner for Financial Growth',
  ogImage,
  ogType = 'website',
  schema,
}) => {
  const location = useLocation();
  const defaultTitle = ' | Maxiom Wealth';
  const fullTitle = title ? `${title}${defaultTitle}` : 'Maxiom Wealth';
  const cleanPath = location.pathname.replace(/\/$/, '') || '/';

  // PMS product pages canonical → MAM domain; everything else → MW domain
  const isPmsProduct = PMS_CANONICAL_PREFIXES.some(p => cleanPath.startsWith(p));
  const canonicalDomain = isPmsProduct
    ? 'https://maxiomassetmanagement.com'
    : 'https://maxiomwealth.com';
  const canonicalUrl = `${canonicalDomain}${cleanPath}`;
  const image = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Maxiom Wealth" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default PageTitle;
